import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Level, LevelPagination } from './level.types';
import { BehaviorSubject, Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LevelsService {
  private baseUrl: string;
  private _levels: BehaviorSubject<Level[] | null> = new BehaviorSubject(null);
  private _pagination: BehaviorSubject<LevelPagination | null> = new BehaviorSubject(null);
  private _levelSelection: BehaviorSubject<Level | null> = new BehaviorSubject(null);

  constructor(
    private httpClient: HttpClient
  ) {
    this.baseUrl = `${environment.apiURL}/levels-managment`
  }

  get level$(): Observable<Level[]> {
    return this._levels.asObservable();
  }

  get pagination$(): Observable<LevelPagination> {
    return this._pagination.asObservable();
  }

  list(page: number = 0, size: number = 10, sort: string = 'id', order: 'asc' | 'desc' | '' = 'asc', search: string = ''):
    Observable<LevelPagination> {
    const endpoint: string = this.baseUrl + '/levels';

    return this.httpClient.get<LevelPagination>(endpoint, {
      params: {
        page: '' + page,
        size: '' + size,
        sort,
        order,
        search
      }
    }).pipe(tap((res) => {

      let data: Level[] = [];
      for (let index in res.data) data.push(res.data[index]);

      res.data.forEach(item => {
        item.open = false;
      });

      this._pagination.next(res);
      this._levels.next(res.data);
    }));
  }

  save(data: any, file: File = null) {
    const endpoint: string = this.baseUrl + '/levels';
    const formData = new FormData();
    formData.append('name', data.name);
    formData.append('description', data.description);
    formData.append('points_min', data.points_min);
    formData.append('points_max', data.points_max);
    formData.append('creator_id', data.creator_id);
    formData.append('img', file);
    return this.httpClient.post(endpoint, formData);
  }

  delete(id: number) {
    const endpoint: string = this.baseUrl + '/levels/' + id;
    return this.httpClient.delete(endpoint);
  }

  update(data: any, id: number, file: File = null) {
    const endpoint: string = this.baseUrl + '/levels/' + id;
    const formData = new FormData();
    formData.append('name', data.name);
    formData.append('description', data.description ? data.description: '');
    formData.append('points_min', data.points_min);
    formData.append('points_max', data.points_max);
    
    if(file) formData.append('img', file);
    return this.httpClient.post(endpoint, formData);
  }

  setdetail(level: Level) {
    this._levelSelection.next(level);
  }

  get detaillevel(): Observable<Level> {
    return this._levelSelection.asObservable();
  }

  listSimple() {

    const endpoint: string = this.baseUrl + '/levels/simple';
    return this.httpClient.get(endpoint);
  }
}
